import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { UserStatusGoPage } from '../../lib/userStatus'
import SuccessPopup from '../SuccessPopup'
import Filters from './Filters'
import PersonaAdditionalInfo from './PersonaAdditionalInfo'
import PersonaList from './PersonaList'
import PersonaSidebar from './PersonaSidebar'


export default function PersonaSearchResult() {
    const [showSuccess, setShowSuccess] = useState(false)
    UserStatusGoPage("/persona-result")
    const searchFormData = useSelector((state) => state.searchFormData.value);

    // when open page if we save question show save success popup
    useEffect(() => {
        searchFormData.saveSearch &&
            setShowSuccess(true)
    }, [])
    useEffect(() => {
        // if open save success message hide it in 5s
        setTimeout(() => {
            showSuccess &&
                setShowSuccess(false)
        }, 5000);
    }, [showSuccess])

    return (
        <div className='pt-16 flex xl:pr-[4.75rem] lg:flex-row flex-col pb-20'>
            <SuccessPopup title="Success!" text="Your search was saved successfully!" showPopup={showSuccess} closePopup={() => setShowSuccess(false)} />
            <div className='w-full lg:w-[22%] pr-5 border-r-2'>
                {/* <DemoSidebar /> */}
                <PersonaSidebar />
            </div>
            <div className='w-full lg:w-[78%] md:pl-14'>
                <Filters title="Personas" />
                <PersonaAdditionalInfo />
                <PersonaList />
            </div>
        </div>
    )
}
